import React from "react";
import { Box, Container, Typography, Link, Divider, Grid } from "@mui/material";

const Footer: React.FC = () => {
  return (
    <Box
      component="footer"
      sx={{
        marginTop: 8,
        paddingTop: 6,
        paddingBottom: 4,
        background: "linear-gradient(to bottom, #f8f9fa 0%, #e9ecef 100%)",
        borderTop: "1px solid #dee2e6",
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4} justifyContent="center">
          {/* Navigation Links */}
          <Grid size={{ xs: 12, md: 4 }}>
            <Typography
              variant="h6"
              sx={{ fontWeight: "bold", mb: 2, color: "#333" }}
            >
              Quick Links
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              <Link
                href="/privacy"
                underline="hover"
                sx={{
                  color: "#007BFF",
                  fontSize: "0.95rem",
                  "&:hover": { color: "#0056b3" },
                }}
              >
                Privacy Policy & Terms
              </Link>
              <Link
                href="/support"
                underline="hover"
                sx={{
                  color: "#007BFF",
                  fontSize: "0.95rem",
                  "&:hover": { color: "#0056b3" },
                }}
              >
                Support
              </Link>
              <Link
                href="/download"
                underline="hover"
                sx={{
                  color: "#007BFF",
                  fontSize: "0.95rem",
                  "&:hover": { color: "#0056b3" },
                }}
              >
                Download App
              </Link>
            </Box>
          </Grid>

          {/* App Store Badges */}
          <Grid size={{ xs: 12, md: 4 }}>
            <Typography
              variant="h6"
              sx={{ fontWeight: "bold", mb: 2, color: "#333" }}
            >
              Get the Mobile App
            </Typography>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
                alignItems: { xs: "center", md: "flex-start" },
              }}
            >
              <a
                href="https://apps.apple.com/us/app/actt-study/id6744712322"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none" }}
              >
                <img
                  src="/badges/app-store.svg"
                  alt="Download on the App Store"
                  style={{
                    height: "45px",
                    cursor: "pointer",
                    transition: "transform 0.2s",
                  }}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.transform = "scale(1.05)")
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.transform = "scale(1)")
                  }
                />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=org.acttstudy.actt"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none" }}
              >
                <img
                  src="/badges/google-play.svg"
                  alt="Get it on Google Play"
                  style={{
                    height: "45px",
                    cursor: "pointer",
                    transition: "transform 0.2s",
                  }}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.transform = "scale(1.05)")
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.transform = "scale(1)")
                  }
                />
              </a>
            </Box>
          </Grid>

          {/* About Section */}
          <Grid size={{ xs: 12, md: 4 }}>
            <Typography
              variant="h6"
              sx={{ fontWeight: "bold", mb: 2, color: "#333" }}
            >
              About ACTT Study
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              Aedes Control through Technology-driven Trapping
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Advancing mosquito surveillance through innovative technology and
              community participation.
            </Typography>
          </Grid>
        </Grid>

        <Divider sx={{ my: 3 }} />

        {/* Copyright */}
        <Typography
          variant="body2"
          color="text.secondary"
          align="center"
          sx={{ fontSize: "0.875rem" }}
        >
          © {new Date().getFullYear()} ACTT Study. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
